import { motion } from 'framer-motion';
import { Plane, Trophy, Users } from 'lucide-react';
import TeamSlideshow from './TeamSlideshow';

const chips = [
  { icon: Plane, label: 'Jährliche Teamreise' },
  { icon: Trophy, label: 'Sport & Turniere' },
  { icon: Users, label: 'Offsite-Formate' },
];

const TeamMomente = () => {
  return (
    <section id="mehr-als-ein-job" className="section-warm py-20 md:py-28">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-60px' }}
            transition={{ duration: 0.7 }}
          >
            <p className="text-[11px] uppercase tracking-[0.22em] text-primary-dark font-semibold mb-4">Mehr als ein Job</p>
            <h2 className="font-normal text-foreground mb-6">
              Teamreisen, Turniere, <span className="italic text-primary-dark">echte Freundschaften.</span>
            </h2>
            <p className="text-lg text-muted-foreground leading-relaxed mb-8">
              Wir arbeiten fokussiert, feiern aber auch zusammen. Regelmäßige Team-Incentives wie gemeinsame Reisen nach Valencia, Kart-Sessions oder Lasertag-Abende gehören bei uns fest dazu, weil das Netzwerk aus dem du wächst genauso wichtig ist wie die fachliche Ausbildung.
            </p>
            <ul className="flex flex-wrap gap-2">
              {chips.map((c) => (
                <li
                  key={c.label}
                  className="inline-flex items-center gap-2 rounded-full border border-border bg-background px-4 py-2 text-sm text-foreground"
                >
                  <c.icon className="w-4 h-4 text-primary-dark" strokeWidth={1.8} />
                  {c.label}
                </li>
              ))}
            </ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-60px' }}
            transition={{ duration: 0.7, delay: 0.1 }}
          >
            <TeamSlideshow />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default TeamMomente;
